
import { MatchCompatibility, MusicalCompatibilityFactors } from '@/types';

/**
 * Calculate new match score incorporating musical compatibility
 */
export function calculateNewMatchScore(
  existingScore: MatchCompatibility,
  musicalCompatibility: MusicalCompatibilityFactors
): number {
  // Calculate average of musical compatibility factors
  const musicalAvg = (
    musicalCompatibility.tempoAlignment +
    musicalCompatibility.moodAlignment +
    musicalCompatibility.audienceOverlap +
    musicalCompatibility.artisticComplementarity
  ) / 4;
  
  // Calculate existing score average
  const existingAvg = (
    existingScore.factors.genreOverlap +
    existingScore.factors.roleCompatibility +
    existingScore.factors.popularityMatch +
    existingScore.factors.locationProximity
  ) / 4;
  
  // Combine with higher weight for musical compatibility (60/40 split)
  return Math.round((musicalAvg * 0.6) + (existingAvg * 0.4));
}
